'use strict';

const profiles = Object.freeze({
  allini: Object.freeze({
    id: 'allini',
    name: 'Allini Poker',
    logo: '/brand/allini/logo.png',
    logoDark: '/brand/allini/logo.png',
    favicon: '/brand/allini/icon-192.png',
    icons: Object.freeze([
      Object.freeze({ src: '/brand/allini/icon-192.png', sizes: '192x192', type: 'image/png' }),
      Object.freeze({ src: '/brand/allini/favicon.svg', sizes: 'any', type: 'image/svg+xml' }),
    ]),
  }),
  zipa: Object.freeze({
    id: 'zipa',
    name: 'ZIPA Poker',
    logo: '/brand/zipa/assets/logo/logo-zipa-poker.png',
    logoDark: '/brand/zipa/assets/logo/logo-zipa-poker-white.png',
    favicon: '/brand/zipa/assets/favicon/favicon-32.png',
    icons: Object.freeze([
      Object.freeze({
        src: '/brand/zipa/assets/favicon/favicon-192.png',
        sizes: '192x192',
        type: 'image/png',
      }),
      Object.freeze({
        src: '/brand/zipa/assets/favicon/favicon-512.png',
        sizes: '512x512',
        type: 'image/png',
      }),
    ]),
  }),
});

function resolveBrand(environment, brand) {
  if (!['local', 'staging', 'production'].includes(environment)) {
    throw new Error('DEPLOY_ENV must explicitly be local, staging or production');
  }
  const id =
    brand === undefined || brand === '' ? (environment === 'local' ? 'allini' : undefined) : brand;
  if (!Object.hasOwn(profiles, id || '')) throw new Error('BRAND_PROFILE must be allini or zipa');
  if (environment !== 'local' && id !== 'zipa')
    throw new Error(`${environment} requires BRAND_PROFILE=zipa`);
  const profile = profiles[id];
  return Object.freeze({
    ...profile,
    environment,
    totpIssuer: `${profile.name}${environment === 'staging' ? ' Staging' : ''}`,
  });
}

function resolveBuildBrand(mode, env) {
  const profile = resolveBrand(
    env.VITE_DEPLOY_ENV || (['development', 'test'].includes(mode) ? 'local' : undefined),
    env.VITE_BRAND_PROFILE,
  );
  // Runtime custom names/uploads use settings. Build metadata must describe this profile.
  if (env.VITE_APP_TITLE && env.VITE_APP_TITLE.toLowerCase() !== profile.name.toLowerCase()) {
    throw new Error(
      'VITE_APP_TITLE conflicts with the selected brand profile; use site_name for custom names',
    );
  }
  if (env.VITE_APP_FAVICON && env.VITE_APP_FAVICON !== profile.favicon) {
    throw new Error(
      'VITE_APP_FAVICON conflicts with the selected brand profile; use uploaded branding for custom icons',
    );
  }
  return profile;
}

function effectiveSiteName(profile, custom) {
  return typeof custom === 'string' && custom.trim() ? custom : profile.name;
}

exports.resolveBrand = resolveBrand;
exports.resolveBuildBrand = resolveBuildBrand;
exports.effectiveSiteName = effectiveSiteName;

// Stable installed-app identities follow the existing start URLs.
function buildManifest(profile, app, version) {
  if (!['web', 'dealer'].includes(app)) throw new Error('Unknown PWA app');
  const dealer = app === 'dealer';
  const base = dealer ? '/dealer' : '';
  const title = `${profile.environment === 'production' ? '' : '[TEST] '}${profile.name}`;
  return {
    id: dealer ? '/dealer/' : '/floor',
    name: `${title}${dealer ? ' 荷官台' : ' 管理系統'}`,
    short_name: `${title}${dealer ? ' 荷官' : ''}`,
    description: `${title}${dealer ? ' 荷官操作台' : ' 場管操作台'}`,
    scope: dealer ? '/dealer/' : '/',
    start_url: dealer ? '/dealer/' : '/floor',
    display: 'standalone',
    orientation: dealer ? 'landscape' : 'any',
    theme_color: dealer ? '#1a1c2e' : '#0D4C87',
    background_color: dealer ? '#0d0f1a' : '#FFFFFF',
    icons: version
      ? [192, 512].map((size) => ({
          src: `/api/branding/pwa/${size}.png?v=${encodeURIComponent(version)}`,
          sizes: `${size}x${size}`,
          type: 'image/png',
          purpose: 'any',
        }))
      : profile.icons.map((icon) => ({ ...icon, src: `${base}${icon.src}` })),
  };
}
exports.buildManifest = buildManifest;
